
import InventoryAPIService from '@/modules/inventory/services/apiService'

import ReportView  from '@/modules/reporting/views/report.vue'

export default class StockModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.inventoryService = new InventoryAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/inventory/stock',
        name: 'StockList',
        component: () => import('@/modules/inventory/views/stockList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Stock',
          menuLink: '/inventory/stock',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Inventory', link: '/inventory'},
          ],
        }
      },
      {
        path: '/inventory/stock/archived',
        name: 'Archived Stock',
        component: () => import('@/modules/inventory/views/stockList.vue'),
        props: {
          filterType: 'archived'
        },
        meta: {
          requiresAuth: true,
          title: 'Archived Stock',
          menuLink: '/inventory/stock/archived',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Inventory', link: '/inventory'},
          ],
        }
      },
      {
        path: '/inventory/stock/new',
        name: 'StockNew',
        component: () => import('@/modules/inventory/views/stockNew.vue'),
        meta: {
          requiresAuth: true,
          title: 'New Stock Item',
          menuLink: '/inventory/stock',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Inventory', link: '/inventory'},
            { title: 'Stock', link: '/inventory/stock'}
          ],
        }
      },
      {
        path: '/inventory/stock/:id(\\d+)',
        name: 'Stock',
        component: () => import('@/modules/inventory/views/stock.vue'),
        meta: {
          requiresAuth: true,
          title: 'Stock',
          menuLink: '/inventory/stock',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Inventory', link: '/inventory'},
            { title: 'Stock', link: '/inventory/stock'}
          ],
        }
      },
      {
        path: '/inventory/transactions',
        name: 'StockTransactions',
        component: () => import('@/modules/inventory/views/stockTransaction.vue'),
        meta: {
          requiresAuth: true,
          title: 'Stock Transactions',
          menuLink: '/inventory/transactions',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Inventory', link: '/inventory'},
          ],
        }
      },
      {
        path: '/inventory/glassblocks',
        name: 'GlassBlockList',
        component: () => import('@/modules/inventory/views/glassBlockList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Glass Blocks',
          menuLink: '/inventory/glassblocks',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Inventory', link: '/inventory'},
          ],
        }
      },
      {
        path: '/inventory/glassoffcuts',
        name: 'GlassOffcutList',
        component: () => import('@/modules/inventory/views/glassOffcutList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Glass Offcuts',
          menuLink: '/inventory/glassoffcuts',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Inventory', link: '/inventory'},
          ],
        }
      },
      {
        path: '/inventory/configuration',
        name: 'InventoryConfiguration',
        component: () => import('@/modules/inventory/views/inventoryConfiguration.vue'),
        meta: {
          requiresAuth: true,
          title: 'Inventory Configuration',
          menuLink: '/inventory/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Inventory', link: '/inventory'}
          ],
        }
      },

      // Stocktake
      {
        path: '/inventory/stocktakes',
        name: 'StockTakeList',
        component: () => import('@/modules/inventory/views/stockTakeList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Stocktake List',
          menuLink: '/inventory/stocktakes',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Inventory', link: '/inventory'}
          ],
        }
      },
      {
        path: '/inventory/stocktakes/new',
        name: 'StockTakeNew',
        component: () => import('@/modules/inventory/views/stockTakeNew.vue'),
        meta: {
          requiresAuth: true,
          title: 'New Stocktake',
          menuLink: '/inventory/stocktakes',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Inventory', link: '/inventory'},
            { title: 'Stocktake List', link: '/inventory/stocktakes'}
          ],
        }
      },
      {
        path: '/inventory/stocktakes/:id(\\d+)',
        name: 'StockTake',
        component: () => import('@/modules/inventory/views/stockTake.vue'),
        meta: {
          requiresAuth: true,
          title: 'Stocktake',
          menuLink: '/inventory/stocktakes',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Inventory', link: '/inventory'},
            { title: 'Stocktake List', link: '/inventory/stocktakes'}
          ],
        }
      },
      {
        path: '/inventory/stocktakes/:id/countingsheetreport',
        name: 'StockTakeCountingSheetReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'StockTake - Counting Sheet Report',
          layout: 'Blank',
          report: {
            url: '/reporting/stocktakes/:id/countingreport',
            variables: ['id']
          },
        }
      },
      {
        path: '/inventory/stocktakes/:id/summaryreport',
        name: 'StockTakeSummaryReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'StockTake - Summary Report',
          layout: 'Blank',
          report: {
            url: '/reporting/stocktakes/:id/summaryreport',
            variables: ['id'],
            options: ['hideStockValues']
          },
        }
      },
    ]
  }
}